import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _mapPatternMatch2TagT, _mapOrderBy2SortBy, _mapTencentDocMimeTyp;
/* eslint-disable max-lines-per-function */

import { getUid } from '@tencent/docs-login';
import { DocType, getDocTypeFromMimeType, MimeType, mimeTypeToExtMap } from '@tencent/docs-mime-types';
import { getXsrfToken } from "../cgi/cookies";
import { SEARCH_FILE_URL, TagType } from "../cgi/search-list";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { OrderBy, SpecialFolderId, SpecialSource, VAGUE_ROOT_ID } from "../common/list-query";
import { requestV2Cgi } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DEFAULT_CREATOR_DOMAIN, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { TencentDocExt, TencentDocMimeType } from "../model/file-node";
import { UserRole } from "../model/permission";
import { SHORT_CUT_KIND } from "../model/shortcut";
import { UNKNOWN_USER_NICK } from "../model/user";
import { forceDivide } from "../utils/math";
/**
 * 在腾讯文档 drive 中搜索符合条件的文件
 *
 * 特殊文件夹 见 {@link SpecialFolderId}
 */
export function searchFile(params) {
  return new SearchListRequest(params).send();
}

/** 自定义时间范围. */

/** 关键词信息 */

/** 关键字匹配的种类 */
export var PatternMatch = /*#__PURE__*/function (PatternMatch) {
  PatternMatch["Title"] = "Title";
  PatternMatch["Content"] = "Content";
  PatternMatch["OwnerNick"] = "OwnerNick";
  return PatternMatch;
}({});
export var SearchListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(SearchListRequest, _DriveRequest);
  var _super = _createSuper(SearchListRequest);
  function SearchListRequest() {
    _classCallCheck(this, SearchListRequest);
    return _super.apply(this, arguments);
  }
  _createClass(SearchListRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", requestV2Cgi(payload));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload() {
      var _this$params$pattern$, _this$params$pattern;
      var _this$getFilter = this.getFilter(),
        extFilter = _this$getFilter.extFilter,
        folderFilter = _this$getFilter.folderFilter;
      var data = {
        method: 'post',
        url: SEARCH_FILE_URL,
        data: {
          directory_file_id: this.getDirectoryFileId(),
          pattern: (_this$params$pattern$ = (_this$params$pattern = this.params.pattern) === null || _this$params$pattern === void 0 ? void 0 : _this$params$pattern.keyword) !== null && _this$params$pattern$ !== void 0 ? _this$params$pattern$ : '',
          sort_rules: this.getSortRule(),
          tag_info: this.getTagInfo(),
          uid: getUid() || '',
          xsrf: getXsrfToken()
        }
      };
      if (folderFilter) {
        Object.assign(data.data, {
          folder_filter: {
            is_folder: true
          }
        });
      } else {
        Object.assign(data.data, {
          ext_filter: {
            extension: extFilter
          }
        });
      }
      if (this.params.time) {
        var _this$params$time = this.params.time,
          by = _this$params$time.by,
          from = _this$params$time.from,
          to = _this$params$time.to;
        Object.assign(data.data, {
          range: [{
            range_by: mapOrderBy2SortBy[by],
            content: "".concat(from, "-").concat(to),
            content_type: 3
          }]
        });
      }
      if (this.params.source) {
        Object.assign(data.data, {
          owner_filter: {
            is_owner: this.params.source === SpecialSource.Mine
          }
        });
      }
      return data;
    }
  }, {
    key: "getResult",
    value: function getResult() {
      var _this$response$result,
        _this$response$result2,
        _this = this;
      if (!this.response) {
        throw new DriveApiError({
          name: "SearchListResultError",
          message: '[result.fileSearchResults] in response is empty. Please catch this error to check request & response.',
          params: this.params,
          payload: this.payload,
          response: this.response
        });
      }
      var fileSearchResult = (_this$response$result = (_this$response$result2 = this.response.result.fileSearchResults) === null || _this$response$result2 === void 0 ? void 0 : _this$response$result2[0]) !== null && _this$response$result !== void 0 ? _this$response$result : {};
      if (!fileSearchResult.result) {
        return {
          items: [],
          count: 0,
          hasNext: false
        };
      }
      return {
        items: fileSearchResult.result.reduce(function (prev, curr) {
          curr.fileDataList.forEach(function (searchFile) {
            var _getDocTypeFromMimeTy;
            var searchFileNode = {
              highlight: curr.highlight,
              kind: '',
              id: searchFile.isLink ? searchFile.fileId : searchFile.collaborateSrcFileId || searchFile.fileId,
              // 优先使用「与我共享」原文件 Id
              title: searchFile.fileName,
              collaborationFlag: Number(searchFile.collaborationFlag) || 0,
              createTs: forceDivide(parseInt(searchFile.createTime, 10), 1000),
              creator: {
                uid: searchFile.creator,
                nick: UNKNOWN_USER_NICK
              },
              docType: (_getDocTypeFromMimeTy = getDocTypeFromMimeType(searchFile.mimeType)) !== null && _getDocTypeFromMimeTy !== void 0 ? _getDocTypeFromMimeTy : DocType.Unknown,
              iconUrl: searchFile.icon,
              lastBrowseTs: forceDivide(parseInt(searchFile.accessTime, 10), 1000),
              // 目前不支持搜索回收站里的项，所以都先给 0
              lastDeleteTs: 0,
              lastModifyTs: forceDivide(parseInt(searchFile.modifyTime, 10), 1000),
              lastModifier: {
                uid: searchFile.modifyUid,
                nick: searchFile.modifyNick
              },
              mimeType: searchFile.mimeType,
              owner: {
                uid: searchFile.owner,
                nick: searchFile.ownerNick
              },
              originParentId: null,
              parentId: searchFile.parentFileId,
              thirdAppId: null,
              isOwnedByMe: getUid() === searchFile.owner
            };
            switch (true) {
              case _this.shouldBeShortcut(searchFile):
                {
                  Object.assign(searchFileNode, {
                    kind: SHORT_CUT_KIND,
                    targetId: searchFile.linkSrcFileId,
                    ext: searchFile.extension,
                    clientId: null,
                    creatorDomainId: DEFAULT_CREATOR_DOMAIN,
                    domainId: searchFile.domainId,
                    groupChatKey: null,
                    groupName: null,
                    isCollected: searchFile.isStar,
                    isPinned: null,
                    lastCollectTs: 0,
                    lastPinnedTs: 0,
                    officialAuthInfo: searchFile.officialAuthInfo,
                    personalizeInfo: searchFile.personalizeInfo,
                    policy: searchFile.docPolicy,
                    source: searchFile.docSource,
                    status: searchFile.isDelete || searchFile.isTrash ? DocStatus.Deleted : DocStatus.Normal,
                    // 将回收站和完全删除归为删除状态
                    tenantId: null,
                    thumbnailUrl: searchFile.thumbnailUrl,
                    url: searchFile.docUrl,
                    weDriveInfo: null
                  });
                  break;
                }
              case _this.shouldBeDriveFile(searchFile):
                {
                  Object.assign(searchFileNode, {
                    kind: DRIVE_FILE_KIND,
                    ext: searchFile.extension,
                    clientId: null,
                    creatorDomainId: DEFAULT_CREATOR_DOMAIN,
                    domainId: searchFile.domainId,
                    driveFileType: DriveFileType.CLOUD,
                    groupChatKey: null,
                    groupName: null,
                    isCollected: searchFile.isStar,
                    isPinned: null,
                    lastCollectTs: 0,
                    lastPinnedTs: 0,
                    officialAuthInfo: searchFile.officialAuthInfo,
                    personalizeInfo: searchFile.personalizeInfo,
                    policy: searchFile.docPolicy,
                    source: searchFile.docSource,
                    status: searchFile.isDelete || searchFile.isTrash ? DocStatus.Deleted : DocStatus.Normal,
                    // 将回收站和完全删除归为删除状态
                    tenantId: null,
                    thumbnailUrl: searchFile.thumbnailUrl,
                    url: searchFile.docUrl,
                    weDriveInfo: null
                  });
                  break;
                }
              case _this.shouldBeCollaborationSpace(searchFile):
                {
                  Object.assign(searchFileNode, {
                    kind: COLLABORATION_SPACE_KIND,
                    // 搜索列表目前没有权限，且交互上无法进行操作
                    attribute: {},
                    roleId: UserRole.Unauthorized,
                    groupInfo: null
                  });
                  break;
                }
              case _this.shouldBeDriveFolder(searchFile):
                {
                  Object.assign(searchFileNode, {
                    kind: DRIVE_FOLDER_KIND,
                    // 目前只能搜到自己的数据，因此文件夹都有权限
                    attribute: FOLDER_ATTRIBUTE
                  });
                  break;
                }
              default:
                {
                  throw new DriveApiError({
                    name: "SearchListResultError",
                    message: 'Unknown kind of [SearchFile]. Catch this error and check the data structure of this [SearchFile] in error context.',
                    params: _this.params,
                    payload: _this.payload,
                    response: _this.response,
                    context: {
                      searchFile: searchFile
                    }
                  });
                }
            }
            prev.push(searchFileNode);
          });
          return prev;
        }, []),
        count: Number(fileSearchResult.total),
        hasNext: !fileSearchResult.isOver
      };
    }
  }, {
    key: "getDirectoryFileId",
    value: function getDirectoryFileId() {
      var folderId = this.params.folderId;
      var directoryFileId = this.params.folderId;
      if (folderId === VAGUE_ROOT_ID) {
        console.warn("[DriveApi]: \"".concat(VAGUE_ROOT_ID, "\" can not specify a special folder precisely. ") + 'DriveApi has automatically converted it to [SpecialFolderId.MyDoc]. Please use [SpecialFolderId.MyDoc] next time.');
        directoryFileId = SpecialFolderId.MyDoc;
      }
      var isSpecialFolderId = Object.values(SpecialFolderId).some(function (specialFolderId) {
        return specialFolderId === directoryFileId;
      });
      if (isSpecialFolderId && directoryFileId !== SpecialFolderId.MyDoc) {
        throw new DriveApiError({
          name: "SearchListParamsError",
          message: 'This api does not support to query list in [SpecialFolders] except [SpecialFolderId.MyDoc].' + 'Please use [SpecialFolderId.MyDoc] or normal folder id.',
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            errorFolderId: directoryFileId,
            supportFolderId: 'Any folder id like \'FHdKhuPuJTiT\' to search in specific folder or [SpecialFolderId.MyDoc] to search in MyDoc.'
          }
        });
      }

      // 在根目录搜索时，后台接受空字符串作为 directory_file_id
      return directoryFileId === SpecialFolderId.MyDoc ? '' : directoryFileId;
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      var mimeTypes = this.params.mimeTypes;
      if (!(mimeTypes !== null && mimeTypes !== void 0 && mimeTypes.length)) {
        return {
          extFilter: [],
          folderFilter: false
        };
      }
      var unsupportedMimeTypes = [];
      var extFilter = [];
      var folderFilter = false;
      var _iterator = _createForOfIteratorHelper(mimeTypes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mimeType = _step.value;
          if (mimeType === TencentDocMimeType.TecentFolder) {
            folderFilter = true;
            continue;
          }
          if (mapTencentDocMimeType2Ext[mimeType]) {
            extFilter.push(mapTencentDocMimeType2Ext[mimeType]);
          } else if (mimeTypeToExtMap[mimeType]) {
            extFilter.push.apply(extFilter, _toConsumableArray(mimeTypeToExtMap[mimeType]));
          } else {
            unsupportedMimeTypes.push(mimeType);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (unsupportedMimeTypes.length > 0) {
        throw new DriveApiError({
          name: "SearchListParamsError",
          message: 'This api does not support to filter items by some of the given MIME types. Catch this error and check supported and unsupported MIME types in error context.',
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            unsupportedMimeTypes: unsupportedMimeTypes,
            supportMimeTypes: Object.keys(mapTencentDocMimeType2Ext)
          }
        });
      }
      return {
        extFilter: extFilter,
        folderFilter: folderFilter
      };
    }
  }, {
    key: "getSortRule",
    value: function getSortRule() {
      var _this2 = this;
      return this.params.orders.map(function (order) {
        var sortBy = mapOrderBy2SortBy[order.by];
        if (!sortBy) {
          throw new DriveApiError({
            name: "SearchListParamsError",
            message: "This api does not support to order list by ".concat(order.by, ". Please use another [OrderBy]."),
            params: _this2.params,
            payload: _this2.payload,
            response: _this2.response,
            context: {
              errorOrderBy: order.by,
              mapOrderBy2SortBy: mapOrderBy2SortBy
            }
          });
        }
        return {
          sort_by: sortBy,
          asc: order.asc
        };
      });
    }
  }, {
    key: "getTagInfo",
    value: function getTagInfo() {
      if (!this.params.pattern) return [];
      return [{
        tag_type: mapPatternMatch2TagType[this.params.pattern.match],
        from: this.params.offset,
        // size 和 limit 是同一个
        size: this.params.limit,
        limit: this.params.limit
      }];
    }
  }, {
    key: "shouldBeShortcut",
    value: function shouldBeShortcut(searchFile) {
      return searchFile.isLink;
    }
  }, {
    key: "shouldBeDriveFile",
    value: function shouldBeDriveFile(searchFile) {
      return !searchFile.isFolder && !searchFile.isLink;
    }
  }, {
    key: "shouldBeDriveFolder",
    value: function shouldBeDriveFolder(searchFile) {
      return searchFile.isFolder;
    }
  }, {
    key: "shouldBeCollaborationSpace",
    value: function shouldBeCollaborationSpace(searchFile) {
      return searchFile.isFolder && searchFile.collaborationFlag === 1;
    }
  }]);
  return SearchListRequest;
}(DriveRequest);
var mapPatternMatch2TagType = (_mapPatternMatch2TagT = {}, _defineProperty(_mapPatternMatch2TagT, PatternMatch.Content, TagType.Content), _defineProperty(_mapPatternMatch2TagT, PatternMatch.OwnerNick, TagType.OwnerNick), _defineProperty(_mapPatternMatch2TagT, PatternMatch.Title, TagType.Title), _mapPatternMatch2TagT);
var mapOrderBy2SortBy = (_mapOrderBy2SortBy = {}, _defineProperty(_mapOrderBy2SortBy, OrderBy.AccessTime, 'access_time'), _defineProperty(_mapOrderBy2SortBy, OrderBy.CreateTime, 'create_time'), _defineProperty(_mapOrderBy2SortBy, OrderBy.ModifyTime, 'modify_time'), _mapOrderBy2SortBy);
var mapTencentDocMimeType2Ext = (_mapTencentDocMimeTyp = {}, _defineProperty(_mapTencentDocMimeTyp, MimeType.Doc, TencentDocExt.TencentDoc), _defineProperty(_mapTencentDocMimeTyp, MimeType.Sheet, TencentDocExt.TencentSheet), _defineProperty(_mapTencentDocMimeTyp, MimeType.Slide, TencentDocExt.TencentSlide), _defineProperty(_mapTencentDocMimeTyp, MimeType.Form, TencentDocExt.TencentForm), _defineProperty(_mapTencentDocMimeTyp, MimeType.Pdf, TencentDocExt.PDF), _defineProperty(_mapTencentDocMimeTyp, MimeType.SmartCanvas, TencentDocExt.SmartCanvas), _defineProperty(_mapTencentDocMimeTyp, MimeType.SmartSheet, TencentDocExt.SmartSheet), _defineProperty(_mapTencentDocMimeTyp, MimeType.Mind, TencentDocExt.ProcessOnMindMap), _defineProperty(_mapTencentDocMimeTyp, MimeType.FlowChart, TencentDocExt.ProcessOnFlowChart), _defineProperty(_mapTencentDocMimeTyp, MimeType.Rec, TencentDocExt.SogouSpeech), _defineProperty(_mapTencentDocMimeTyp, MimeType.Board, TencentDocExt.Board), _defineProperty(_mapTencentDocMimeTyp, MimeType.Markdown, TencentDocExt.Markdown), _mapTencentDocMimeTyp);
//# sourceMappingURL=search-list.js.map